import Link from 'next/link'

export const QuestionItem = ({
    author,
    text,
    answer,
    date_added,
    date_modified,
    product_href,
    product_title,
}) => {
    const dateAddedModified = date_added
        .split(' ')[0]
        .split('-')
        .reverse()
        .join('.')
    const dateModified = date_modified
        .split(' ')[0]
        .split('-')
        .reverse()
        .join('.')
    return (
        <div className={'QuestionItem'}>
            <div className={'question'}>
                <h4>
                    <img src="/icons/quest-icon.svg" alt={'quest-icon'} />
                    {author}
                </h4>
                <p>{text}</p>
                <div className={'bottom-info'}>
                    <Link href={`/${product_href}`}>{product_title}</Link>
                    <span>{dateAddedModified}</span>
                </div>
            </div>
            {!!answer.length && (
                <div className={'answer'}>
                    <h4>Academie.club</h4>
                    <p>{answer}</p>
                    <span>{dateModified}</span>
                </div>
            )}
        </div>
    )
}
